export const changeStatusOfIngFaqConditions = (
  isCampaignActive,
  isHelpActive,
  url
) => {
  return {
    type: "CHANGE_STATUS_OF_INGFAQ_CONDITIONS",
    isCampaignActive,
    isHelpActive,
    url,
  };
};
